import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import ImageLibpixel from "./image-libpixel.js";
import { _ } from "../utils/i18n";

const Container = styled.div`
  display: flex;
  margin: 15px 0;
  justify-content: center;
  posistion: relative;
  height: 427px;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  &:hover div {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.16);
  }
  &:hover img {
    transform: scale(1.1);
  }
  @media (max-width: 1024px) {
    padding: 20px;
  }
  @media (max-width: 440px) {
    flex-direction: column;
    height: auto;
    width: 100%;
    padding: 0;
  }
`;
const TextContainer = styled.div`
  posistion: relative;
  z-index: 5;
  margin-left: -100px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  max-width: 648px;
  width: 100%;
  height: 277px;
  background-color: #f7f7f7;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
  @media (max-width: 440px) {
    height: auto;
    margin-left: 0;
    padding: 20px;
    background-color: transparent;
  }
`;
const Img = styled(ImageLibpixel)`
  position: relative;
  z-index: 0;
  overflow: hidden;
  transition: all 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  width: 100%;
  object-fit: cover;
  max-width: 654px;
  height: 394px;
  @media (max-width: 440px) {
    height: 200px;
    width: 100%;
  }
`;
const ImgLink = styled((props) => <Link {...props} />)`
  overflow: hidden;
  display: flex;
  width: 100%;
  max-width: 654px;
  height: 394px;
  margin-top: 20px;
  @media (max-width: 440px) {
    height: 200px;
    width: 100%;
    margin-top: 0;
  }
`;
const Title = styled.h2`
  font-size: 1.7rem;
  margin-top: 0;
  font-weight: 400;
`;
const Description = styled.p`
  font-size: 1.1rem;
  @media (max-width: 440px) {
    font-size: 0.9rem;
  }
`;
const DescriptionLink = styled((props) => <Link {...props} />)`
  display: block;
  padding-left: 0px;
  padding-top: 15px;
  color: #f15e4e !important;
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: 440px) {
    padding: 8px 15px;
    border: 1px solid #333;
    color: #333;
    border-radius: 5px;
    text-decoration: none;
    margin-top: 10px;
    display: inline-block;
    &:visited {
      color: #333;
    }
  }
`;

export default function ServiceCard(props) {
  return (
    <Container
      itemScope
      itemType="http://schema.org/Service"
      style={props.innerStyle}
      data-sal="slide-up"
      data-sal-delay="0"
      data-sal-duration="500"
      data-sal-easing="easeOutQuad"
    >
      <meta itemProp="serviceType" content={props.title} />
      <ImgLink itemProp="url" to={props.link}>
        <Img itemProp="image" alt={_("post")} src={props.imgUrl} />
      </ImgLink>
      <TextContainer>
        <Title itemProp="name">
          {props.title &&
            props.title
              .replace("&#038;", "&")
              .replace("&amp;", "&")
              .replace("&#8211;", "-")}
        </Title>
        <Description itemProp="description">
          {props.content} <br />
          <DescriptionLink to={props.link} itemProp="url">
            {_("Se våre tjenester")}
          </DescriptionLink>
        </Description>
      </TextContainer>
    </Container>
  );
}

ServiceCard.propTypes = {
  link: PropTypes.string,
  imgUrl: PropTypes.string,
  title: PropTypes.string.isRequired,
  innerStyle: PropTypes.object,
  content: PropTypes.string.isRequired,
};

ServiceCard.defaultProps = {
  link: "",
  imgUrl: "",
  innerStyle: undefined,
};
